<template>
  <div id="me_new_ctr">
    <!--openinstall的cdn链接-->
    <remote-js src="//res.cdn.openinstall.io/openinstall.js"></remote-js>
    <!-- 顶部的图片轮播区域 -->
    <div class="top_photo relativeItem">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide class="slide_div" v-for="(n, i) in uinfo.show_list" :key="i">
          <img class="imgBlock noevents-img" :src="n.path" />
        </swiper-slide>
      </swiper>
      <div class="absoluteItem pagni_main flex-box">
        <div class="dot_div flex-box">
          <div
            :class="['dot_con', { dot_bder: acIdx == i }]"
            v-for="(n, i) in uinfo.show_list"
            :key="i"
            @click="handleDotFun(i)"
          >
            <img class="imgBlock noevents-img" :src="n.path" />
          </div>
        </div>
        <div class="look_photo" id="look-photo">查看相册</div>
      </div>
    </div>

    <!-- 账号信息部分 -->
    <div class="big_con relativeItem">
      <img class="imgBlock noevents-img" src="../../../assets/newPerson/head.png" />
      <div class="ident_info absoluteItem flex-box">
        <div class="info_box">
          <div class="info_con flex-box">
            <div class="dt_con relativeItem">
              <a
                class="allA"
                @click="goH5Room"
                v-show="uinfo.isshow == '1' && uinfo.jump_live == '1'"
              ></a>
              <a
                class="allA"
                id="no-live"
                v-show="uinfo.isshow == '1' && uinfo.jump_live == '0'"
              ></a>
              <div class="me_avt relativeItem">
                <img class="imgBlock noevents-img" :src="uinfo.avatar" />
                <p class="absoluteItem p_live centerX" v-if="uinfo.isshow == 1">直播中</p>
              </div>
              <div class="w1 absoluteItem" v-if="uinfo.isshow == 1"></div>
              <div class="w2 absoluteItem" v-if="uinfo.isshow == 1"></div>
            </div>

            <div class="me_info_con flex-box">
              <p class="name_p apostrophe">{{ uinfo.nickname }}</p>
              <div class="flex-box sex_fa">
                <div
                  class="sex_con flex-box"
                  :class="{ male: uinfo.gender == '1', famale: uinfo.gender == '0' }"
                >
                  <p>{{ uinfo.age }}</p>
                </div>
                <div class="gj_div">
                  <img class="imgBlock noevents-img" :src="uinfo.network_guizhu" />
                </div>
              </div>
            </div>
          </div>
          <div class="id_card flex-box">
            <div class="card_imgbox">
              <img
                class="imgBlock noevents-img"
                src="../../../assets/newPerson/card.png"
              />
            </div>
            <div class="location_div">
              <span v-if="uinfo.constellation != ''">{{ uinfo.constellation }}</span
              ><span v-if="uinfo.province != ''">.{{ uinfo.province }}</span>
              <span v-if="uinfo.city != ''">.{{ uinfo.city }}</span>
            </div>
          </div>
        </div>

        <div class="level_div flex-box">
          <div class="level_imgs">
            <img
              class="imgBlock noevents-img"
              :src="uinfo.network_pointlevel_big"
              v-if="uinfo.isachor == '1'"
            />
            <img class="imgBlock noevents-img" :src="uinfo.wealthImg" v-else />
          </div>
          <div class="dj_con flex-box" v-if="uinfo.isachor == '1'">
            <p>主播等级</p>
            <p>{{ uinfo.anchor_level }}</p>
          </div>
          <div class="dj_con flex-box" v-else>
            <p>财富等级</p>
            <p>{{ uinfo.wealth_level_number }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 资料-->
    <div class="ctr_swipe">
      <ul class="main_tit flex-box">
        <li class="li_tson flex-box relativeItem tit_active">
          <p class="tit_p1">资料</p>
        </li>
      </ul>
      <div class="all_main">
        <div id="means_idx">
          <div class="motto_box relativeItem">
            <p class="dou_lft absoluteItem">‘‘</p>
            <p class="dou_rgt absoluteItem">’’</p>
            <p class="text_p relativeItem">
              {{ uinfo.gxqm }}
            </p>
          </div>

          <div class="live_room_con" v-show="uinfo.isshow == 1">
            <p class="tit_pline">{{ meTa }}的直播间</p>
            <div class="room_me relativeItem">
              <!--背景图-->
              <img
                :src="myStudio.bgimg"
                v-if="myStudio.bgimg != undefined"
                class="rm_bk_img imgBlock absoluteItem"
              />

              <!--主体内容-->
              <div class="rm_ab absoluteItem flex-box">
                <div class="rm_info flex-box">
                  <div class="rm_avtar">
                    <img class="imgBlock noevents-img" :src="uinfo.avatar" />
                  </div>
                  <div class="status_con">
                    <div class="l_sta">
                      <p>直播中</p>
                    </div>
                    <p class="p_hu apostrophe">{{ sex }}的守护</p>
                    <p class="hu_per apostrophe" v-if="myStudio.nickname">
                      {{ myStudio.nickname }}
                    </p>
                  </div>
                </div>
                <div class="fs_con relativeItem" id="fs-con">{{ sex }}的粉丝团</div>
              </div>
            </div>
          </div>
          <!-- 我的标签 -->
          <div class="live_room_con" v-if="label.length > 0">
            <p class="tit_pline">我的标签</p>
            <div class="tag_box">
              <ul class="flex-box">
                <li
                  v-for="(n, i) in uinfo.label"
                  :key="i"
                  :style="{ color: n.content3, background: n.content2 }"
                >
                  {{ n.content1 }}
                </li>
              </ul>
            </div>
          </div>

          <!-- 个人成就 -->
          <div
            class="live_room_con"
            v-if="achievement_medal.length > 0 || fans_medal.length > 0"
          >
            <p class="tit_pline">个人成就</p>
            <div class="achive_box flex-box">
              <div class="ac_lft" v-if="achievement_medal.length > 0">
                <div class="flex-box medal_tit">
                  <p>勋章墙</p>
                  <p>{{ achievement_medal.length }}</p>
                </div>
                <div class="relativeItem">
                  <ul class="scro_ach flex-box">
                    <li v-for="(n, i) in achievement_medal" :key="i">
                      <img class="imgBlock noevents-img" :src="n.picSrc" />
                    </li>
                  </ul>
                  <div class="liner_empty absoluteItem"></div>
                </div>
              </div>
              <div class="ac_rgt" v-if="fans_medal.length > 0">
                <div class="flex-box bean_tit">
                  <p>粉丝牌</p>
                  <p>{{ fans_medal.length }}</p>
                </div>
                <div class="relativeItem">
                  <ul class="scro_ach flex-box">
                    <li v-for="(n, i) in fans_medal" :key="i">
                      <img class="imgBlock noevents-img" :src="n.avatar" />
                    </li>
                  </ul>
                  <div class="liner_empty absoluteItem"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- tade社交圈 -->
          <div class="live_room_con relativeItem" v-show="groupList.length > 0">
            <a id="live-room" class="allA"></a>
            <p class="tit_pline">{{ meTa }}的社交圈</p>
            <div class="social_box flex-box" v-for="(n, index) in groupList" :key="index">
              <div class="soc_con relativeItem">
                <img class="imgBlock noevents-img" :src="n.avatar" />
                <div class="info_num absoluteItem">
                  <p>{{ n.groupName }}</p>
                  <p>{{ n.peopleTrue }}人在线</p>
                </div>
                <div class="all_per absoluteItem">{{ n.peopleMix }}位成员</div>
              </div>
            </div>
          </div>
          <!-- 个人信息 -->
          <div class="live_room_con">
            <p class="tit_pline">个人信息</p>
            <div class="person_box">
              <ul>
                <li class="flex-box line_info">
                  <p>朱贝号</p>
                  <div class="per_rht">{{ uinfo.usernumber }}</div>
                </li>
                <li class="flex-box line_info">
                  <p>星座</p>
                  <div class="per_rht flex-box conste_box">
                    <img class="imgBlock noevents-img" :src="uinfo.constellation_img" />
                    <p>{{ uinfo.constellation }}</p>
                  </div>
                </li>
                <li class="flex-box line_info">
                  <p>活跃等级</p>
                  <div class="level_img">
                    <img class="imgBlock noevents-img" :src="uinfo.network_level" />
                  </div>
                </li>
                <li class="flex-box line_info">
                  <p>主播等级</p>
                  <div class="level_img">
                    <img class="imgBlock noevents-img" :src="uinfo.network_pointlevel" />
                  </div>
                </li>
                <li class="flex-box line_info">
                  <p>财富等级</p>
                  <div class="level_img">
                    <img
                      class="imgBlock noevents-img"
                      :src="uinfo.network_wealth_level_img"
                    />
                  </div>
                </li>
                <li class="flex-box line_info">
                  <p>行业</p>
                  <div class="per_rht">{{ uinfo.job }}</div>
                </li>
                <li class="flex-box line_info">
                  <p>现居</p>
                  <div class="per_rht" v-if="uinfo.province != ''">
                    {{ uinfo.province }} {{ uinfo.city }}
                  </div>
                  <div class="per_rht" v-else>保密</div>
                </li>
                <li class="flex-box line_info">
                  <p>情感状态</p>
                  <div class="per_rht">{{ uinfo.emotion }}</div>
                </li>
                <li class="flex-box line_info ali_start">
                  <p>个性签名</p>
                  <div class="per_rht">
                    {{ uinfo.gxqm }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- Ta的回答 -->
          <div class="live_room_con" v-if="answerList.length > 0">
            <p class="tit_pline">{{ meTa }}的回答</p>
            <div class="answer_box">
              <ul>
                <li
                  v-for="(n, i) in answerList"
                  :key="i"
                  :style="{ background: n.content_color }"
                >
                  <p>{{ n.content1 }}</p>
                  <p>{{ n.content2 }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bot_down flex-box">
      <div class="zb_logo">
        <img class="imgBlock noevents-img" src="../../../assets/share/zhubei.png" />
      </div>
      <div id="d-button" class="open_app">打开APP</div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

var vm = null;

export default {
  name: "new_ctr",
  components: {
    swiper,
    swiperSlide,
    "remote-js": {
      render(createElement) {
        return createElement("script", {
          attrs: { type: "text/javascript", src: this.src },
        });
      },
      props: {
        src: { type: String, required: true },
      },
    },
  },
  data() {
    return {
      isLive: 1, //0未开播  1直播中
      acIdx: 0,
      swiperOption: {
        speed: 500,
        autoplay: false,
        loop: false,
        self: this,
        centeredSlides: true,
        autoHeight: true, //高度随内容变化
        on: {
          slideChangeTransitionStart: function () {
            //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，
            //原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
            vm.acIdx = this.realIndex;
          },
          init: function () {
            //Swiper初始化
            vm.acIdx = 0;
          },
        },
      },
      meTa: "TA", //我  或者Ta
      sex: "她",
      label: [], //个人标签
      groupList: [], //社区
      answerList: [],
      achievement_medal: [], //成就勋章列表
      fans_medal: [], //粉丝勋章列表
      uinfo: [], //用户个人信息
      myStudio: [], //守护的相关信息
    };
  },
  methods: {
    /**openinstall相关事务 */
    open_install_thing() {
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*openinstall初始化完成的回调函数，可选*/
          onready: function () {
            var m = this,
              tiyan_button = document.getElementById("d-button"),
              button2 = document.getElementById("look-photo"),
              button3 = document.getElementById("fs-con"),
              button4 = document.getElementById("live-room"),
              button5 = document.getElementById("no-live");

            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            tiyan_button.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button3.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button2.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button4.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
            button5.onclick = function () {
              m.wakeupOrInstall();
              return false;
            };
          },
        },
        data
      );
    },

    // 顶部小图片的点击
    handleDotFun(i) {
      this.acIdx = i;
      this.$refs.mySwiper.swiper.slideTo(this.acIdx);
    },

    // 在直播的就前往直播间
    goH5Room() {
      if (this.uinfo.jump_live == "1") {
        this.$router.push({
          path: `/video_share?share_live=1&roomnumber=${this.uinfo.usernumber}&uid=${this.$router.query.uid}`,
        });
      }
    },

    // 下载页面
    goDownLoad() {
      this.$tool.download();
    },

    //获取个人中心数据
    get_uinfo() {
      //从链接上获取被分享者的id
      //用于获取个人数据
      let _this = this;
      let data = {
        touserid: this.$route.query.shared_userid,
        type: 0,
        appversion: "1.0",
      };
      this.$jsonp(this.$apis("open_userinfo"), data, (res) => {
        //循环筛选已经完成的勋章墙
        res.data.data.achievement_medal.forEach((e) => {
          if (e.isover == "1") {
            _this.achievement_medal.push(e);
          }
        });
        _this.fans_medal = res.data.data.medallist;
        _this.uinfo = res.data.data.userinfo;
        _this.answerList = _this.uinfo.myIssue;
        _this.label = _this.uinfo.label;
        _this.groupList = _this.uinfo.groupList;
        _this.myStudio = _this.uinfo.myStudio;
        if (_this.uinfo.gender == "1") {
          _this.sex = "他";
        }
      });
    },
  },
  created() {
    vm = this;
  },
  mounted() {
    this.$tool.setTitle("我的名字");
    this.$appAc.app_refreshUsable(0); //阻止安卓的刷新
    this.get_uinfo();
    //初始化openinstall
    let _this = this;
    setTimeout(() => {
      _this.open_install_thing();
    }, 1000);
  },
  watch: {},
};
</script>

<style scoped>
#me_new_ctr {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  padding-bottom: 68px;
}
.top_photo {
  width: 100%;
  height: 315px;
}
.slide_div img {
  width: 100%;
  height: 315px;
}
.pagni_main {
  width: 100%;
  bottom: 30px;
  padding: 0 3%;
  justify-content: space-between;
  align-items: center;
  z-index: 3;
}
.pagni_main .dot_con img {
  width: 100%;
  height: 100%;
}
.dot_con {
  width: 39px;
  height: 39px;
  margin-right: 8px;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
}
.dot_bder {
  border: 2px solid #e0e5e6;
}
.add_div {
  width: 39px;
  height: 39px;
  text-align: center;
  line-height: 39px;
  border-radius: 6px;
  border: 2px solid #7f7472;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 20px;
}
.look_photo {
  font-size: 0.8125rem;
  color: #e0e5e6;
  padding-right: 16px;
}
.look_photo::after {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  border: 2px solid #e0e5e6;
  border-left: none;
  border-bottom: none;
  border-radius: 1px;
  top: 50%;
  transform: translateY(-50%) rotateZ(45deg);
  right: 4%;
}
/* 账号信息部分 */
.big_con {
  width: 100%;
  margin-top: -30px;
  z-index: 5;
}
.ident_info {
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 88%;
  padding: 15px 12px;
  justify-content: space-between;
}

.dt_con {
  margin-right: 8px;
  width: 40px;
  height: 40px;
}
.dt_con .allA {
  z-index: 5;
}
.dt_con .w1,
.dt_con .w2 {
  border: 1px solid #ff30bb;
  border-radius: 50%;
  animation: opac 1.5s infinite;
  -webkit-animation: opac 1.5s infinite;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.avt_ani {
  /* border: 1px solid #ff30bb; */
  border-radius: 50%;
  /* animation: avtAni 2s linear alternate infinite;
  -webkit-animation: avtAni 2s linear alternate infinite; */
}
.p_live {
  width: 100%;
  text-align: center;
  top: 0;
  color: #fff;
  font-size: 0.375rem;
  background: -webkit-linear-gradient(left, #ff58c8, #b840ff);
  background: linear-gradient(to right, #ff58c8, #b840ff);
}
.me_avt {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}
.info_con .me_avt img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.me_info_con {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.me_info_con .name_p {
  width: 120px;
  font-size: 1.125rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 3px;
}
.sex_fa {
  align-items: center;
}
.sex_con {
  padding: 1px 4px;
  padding-left: 18px;
  /* height: 15px; */
  border-radius: 10px;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.famale {
  background: url("../../../assets/newPerson/icon(37).png") 2px center no-repeat #ff549b;
  background-size: 18px 18px;
}
.male {
  background: url("../../../assets/newPerson/icon(37).png") 2px center no-repeat #3eaeff;
  background-size: 18px 18px;
}

.sex_con img {
  width: 18px;
  height: 18px;
}
.sex_con p {
  font-size: 0.625rem;
  color: #fff;
  margin-left: 3px;
}
.gj_div img {
  width: 20px;
  height: 20px;
}
.card_imgbox img {
  width: 42px;
  height: 28px;
}
.id_card {
  margin-top: 8px;
  align-items: center;
}
.location_div {
  font-size: 0.75rem;
  color: #333;
  margin-left: 8px;
}
.level_div {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.level_imgs img {
  width: 60px;
  height: 60px;
}
.dj_con {
  align-items: center;
}
.dj_con p:nth-child(1) {
  font-size: 0.75rem;
  font-weight: bold;
  color: #333;
  margin-right: 6px;
}
.dj_con p:nth-child(2) {
  font-size: 0.875rem;
  color: #333;
}
/* 资料 */
.main_tit {
  width: 100%;
  background-color: #fff;
  padding-left: 6%;
  margin: 0 auto;
  padding-bottom: 10px;
  justify-content: flex-start;
  align-items: flex-end;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 6;
}
.main_tit .tit_active {
  font-weight: 600;
  font-size: 1.5rem;
  color: #333;
  align-items: flex-end;
}
.main_tit .tit_active::after {
  position: absolute;
  content: "";
  width: 8px;
  height: 3px;
  border-radius: 1px;
  background-color: #333;
  bottom: -30%;
  right: 40%;
  transform: translateY(-50%);
}

.main_tit .tit_active .num_lip {
  font-size: 1.2rem;
  color: #333;
}
.li_tson {
  margin-right: 16px;
  align-items: flex-end;
  font-size: 0.9375rem;
  color: #333;
}
/* 组件展示的样式 */
.all_main {
  margin-top: 12px;
  padding: 0 6%;
}

/* 底部的下载 */
.bot_down {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 3;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 8px 4%;
}
.zb_logo img {
  width: 120px;
  height: 50px;
}
.open_app {
  color: #fff;
  padding: 10px 13px;
  font-size: 0.875rem;
  border-radius: 20px;
  background: -webkit-linear-gradient(top, #f710ff, #9000ff);
  background: linear-gradient(to bottom, #f710ff, #9000ff);
  box-shadow: 0 0 0 #e8c0ff, 0 2px 8px #e8c0ff, 2px 0 8px #e8c0ff, -2px 0 8px #e8c0ff;
}
/* ---------- */
#means_idx {
  width: 100%;
}

/* 个人宣言 */
.motto_box {
  padding: 16px 40px 16px 40px;
  border-radius: 12px;
  border: 1px solid #dbdbdb;
  min-height: 60px;
  margin: 12px 0;
}
.dou_lft,
.dou_rgt {
  color: #cfd0d1;
  font-weight: bold;
  font-size: 38px;
  padding: 0 8px;
  background-color: #fff;
}
.dou_lft {
  top: -14px;
  left: 5%;
}
.dou_rgt {
  bottom: -32px;
  right: 5%;
}
.motto_box .text_p {
  z-index: 2;
  font-size: 0.875rem;
  color: #333;
}
.live_room_con {
  margin-top: 6px;
}
.live_room_con .allA {
  z-index: 5;
}
.tit_pline {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  padding: 16px 0;
}
.room_me {
  width: 100%;
  background-color: #757ca6;
  height: 88px;
  border-radius: 0.5rem;
}
.rm_bk_img {
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.rm_ab {
  top: 0;
  left: 0;
  z-index: 2;
  padding: 0 6% 0 8%;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}
.rm_ab .rm_avtar {
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 50%;
  overflow: hidden;
}
.l_sta p {
  display: inline-block;
  color: #fff;
  font-size: 0.625rem;
  padding: 3px 8px;
  text-align: center;
  border-radius: 0.75rem;
  background: -webkit-linear-gradient(left top, #ff5768, #ff51c5);
  background: linear-gradient(to right bottom, #ff5768, #ff51c5);
}
.rm_info {
  width: 60%;
  align-items: center;
}
.status_con {
  margin-left: 20px;
}
.status_con .p_hu {
  width: 100px;
  font-size: 0.9375rem;
  color: #fff;
  padding: 1px 0;
}
.status_con .hu_per {
  width: 100px;
  font-size: 0.75rem;
  color: #c5c8d8;
}
.rm_ab .fs_con {
  font-size: 0.75rem;
  color: #fff;
  padding-right: 12px;
}

.rm_ab .fs_con::after {
  position: absolute;
  content: "";
  width: 6px;
  height: 6px;
  border: 1px solid #fff;
  border-left: none;
  border-bottom: none;
  top: 50%;
  transform: translateY(-50%) rotateZ(45deg);
  right: 0%;
}
/* 标签 */
.tag_box {
  width: 100%;
}
.tag_box ul {
  flex-wrap: wrap;
}
.tag_box li {
  margin: 0 10px 10px 0;
  font-size: 0.875rem;
  padding: 5px 10px;
  border-radius: 1rem;
}
/* 成就 */
.achive_box {
  justify-content: space-between;
}
.achive_box .ac_lft,
.achive_box .ac_rgt {
  width: 49%;
  border-radius: 10px;
  padding: 8px 0 8px 8px;
  overflow: hidden;
}
.achive_box .ac_lft {
  background-color: #fefaeb;
}
.achive_box .ac_rgt {
  background-color: #fcf1fb;
}
.medal_tit {
  align-items: center;
}
.ac_lft .medal_tit p:nth-child(1) {
  color: #714b16;
  font-size: 0.8125rem;
}
.ac_lft .medal_tit p:nth-child(2) {
  color: #714b16;
  font-size: 0.8125rem;
  background-color: #fae3b8;
  padding: 1px 5px;
  border-radius: 0.5rem;
  margin-left: 8px;
}
.bean_tit {
  align-items: center;
}
.bean_tit p:nth-child(1) {
  color: #d415c0;
  font-size: 0.8125rem;
}
.bean_tit p:nth-child(2) {
  color: #d415c0;
  font-size: 0.8125rem;
  background-color: #ffccfa;
  padding: 1px 5px;
  border-radius: 0.5rem;
  margin-left: 8px;
}
.liner_empty {
  bottom: -8px;
  right: 0;
  width: 3rem;
  height: 3rem;
  background: -webkit-linear-gradient(
    left,
    rgba(254, 250, 235, 0),
    rgba(254, 250, 235, 1)
  );
  background: linear-gradient(to right, rgba(254, 250, 235, 0), rgba(254, 250, 235, 1));
}
.scro_ach {
  margin-top: 10px;
  overflow-x: scroll;
}
.scro_ach li {
  margin-right: 5px;
}
.scro_ach img {
  width: 2.0625rem;
  height: 2.0625rem;
  border-radius: 50%;
}
/* 社交圈 */
.social_box {
  justify-content: space-between;
  margin-bottom: 6px;
}
.soc_con {
  width: 49%;
  height: 89px;
  overflow: hidden;
  background-color: #ccc;
  border-radius: 10px;
}
.info_num {
  top: 14%;
  left: 8%;
}
.info_num p:nth-child(1) {
  color: #fff;
  font-size: 0.8125rem;
  margin-bottom: 6px;
}
.info_num p:nth-child(2) {
  color: #e5e4e2;
  font-size: 0.6875rem;
}
.all_per {
  right: 0;
  bottom: 12%;
  width: 80%;
  padding: 3px 16px 3px 0;
  text-align: right;
  color: #fff;
  font-size: 0.8125rem;
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.35)
  );
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.35)
  );
}
/* 个人信息 */
.person_box .line_info {
  padding-bottom: 18px;
  align-items: center;
}

.person_box ul .line_info:last-child {
  padding-bottom: 0;
}
.line_info p:nth-child(1) {
  width: 70px;
  font-size: 0.8125rem;
  color: #666;
}
.conste_box img {
  width: 1.125rem;
  height: 1.125rem;
}
.per_rht {
  width: calc(100% - 70px);
  font-size: 0.8125rem;
  color: #333;
}
.level_img img {
  width: 32px;
  height: 14px;
}
.person_box ul .ali_start {
  align-items: flex-start;
}
.per_rht p {
  margin-left: 8px;
}
/* 回答 */
.answer_box li {
  width: 100%;
  padding: 18px 15px;
  color: #333;
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 5px;
  border-radius: 8px;
}
.answer_box li p:nth-child(2) {
  font-size: 0.9375rem;
  padding-top: 8px;
}
</style>
